<mat-icon *ngIf='show' [ngClass]="{'grey': !marked, 'green': marked}">{{icon}}</mat-icon>
